/** Formatting shared by the list and the form. Mirrors backend/services/alerts/deliver.js. */

export function formatValue(value, unit) {
  if (value == null || !Number.isFinite(Number(value))) return '—';
  const v = Number(value);
  switch (unit) {
    case 'ms': return v >= 1000 ? `${(v / 1000).toFixed(v >= 10000 ? 0 : 1).replace(/\.0$/, '')} s` : `${Math.round(v)} ms`;
    case 'usd': return `$${v >= 100 ? v.toFixed(0) : v >= 1 ? v.toFixed(2) : v.toFixed(4)}`;
    case 'percent': return `${v.toFixed(v >= 10 ? 0 : 1).replace(/\.0$/, '')}%`;
    case 'score': return v.toFixed(2);
    default: return Number.isInteger(v) ? v.toLocaleString() : v.toFixed(1);
  }
}

/** The unit a threshold is typed in, as a suffix inside the input. */
export function unitSuffix(unit) {
  return { ms: 'ms', usd: '$', percent: '%', score: '', count: '' }[unit] ?? '';
}

export function timeAgo(iso) {
  if (!iso) return '—';
  const secs = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (secs < 60) return 'just now';
  if (secs < 3600) return `${Math.floor(secs / 60)}m ago`;
  if (secs < 86400) return `${Math.floor(secs / 3600)}h ago`;
  return `${Math.floor(secs / 86400)}d ago`;
}

/** An alert is either on or paused; whether it has fired is the Last triggered column. */
export const STATE_LABEL = { on: 'On', paused: 'Paused' };
export const STATE_TIP = { on: 'On: being checked', paused: 'Paused: not being checked' };
export const STATE_COLOR = { on: 'var(--feedback-success)', paused: 'var(--text-disabled)' };
